import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { LISTING_STATE_DRAFT, LISTING_STATE_PENDING_APPROVAL } from '../../../util/types';
import { priceData } from '../../../util/currency';
import { getListingDisplayDate } from '../../../util/listings';
import { DEFAULT_LISTING_TITLE } from '../../../marketplace-custom-config';
import { SuccessIcon, UpdateCircleIcon } from '../../../icons';
import { formatDateOptions, formatPriceForDisplay } from '../helpers';
import { useManageListingCardContext } from '../ManageListingCardContext';

import css from './ListingInfo.css';
import { useIntl } from 'react-intl';

const StatusBadge = () => {
    const { listing } = useManageListingCardContext();
    const { state } = listing.attributes;

    return (
        <div className={classNames(css.statusBadge, { [css[state]]: !!css[state] })}>
            <code />
            <FormattedMessage id={`ManageListingCard.listingState-${state}`} />
        </div>
    );
};

const ListingDate = () => {
    const { listing } = useManageListingCardContext();
    const intl = useIntl();
    const { state, publicData } = listing.attributes;
    const displayDate = getListingDisplayDate(listing);

    if (!displayDate) return null;

    const datePending = state === LISTING_STATE_DRAFT || state === LISTING_STATE_PENDING_APPROVAL;

    return (
        <div className={css.listingCreationInfo}>
            {datePending ? (
                <code className={css.placeholder} />
            ) : (
                <>
                    {publicData.updatedAt ? (
                        <UpdateCircleIcon />
                    ) : (
                        <SuccessIcon rootClassName={css.createdAtIcon} />
                    )}
                    {intl.formatDate(new Date(displayDate), formatDateOptions)}
                </>
            )}
        </div>
    );
};

const ListingPrice = () => {
    const { listing } = useManageListingCardContext();
    const intl = useIntl();
    const { formattedPrice, priceTitle } = priceData(listing.attributes.price, intl);

    if (!formattedPrice) return <code className={css.pricePlaceholder} />;

    return (
        <div className={css.price}>
            <div className={css.priceValue} title={priceTitle}>
                {formatPriceForDisplay(formattedPrice)}
            </div>
            <div className={css.perUnit}>
                <span>pro Monat</span>
            </div>
        </div>
    );
};

const ListingInfo = () => {
    const { listing } = useManageListingCardContext();
    const { title } = listing.attributes;
    const noTitle = !title || title === DEFAULT_LISTING_TITLE;

    return (
        <div className={css.listingInfoSection}>
            <aside className={css.horseIdentitySection}>
                <h4 className={classNames({ [css.placeholder]: noTitle })}>
                    {noTitle ? null : title}
                </h4>
                <StatusBadge />
            </aside>

            <div className={css.divider} />

            <aside className={css.horseListingSection}>
                <ListingDate />
                <ListingPrice />
            </aside>
        </div>
    );
};

export default ListingInfo;
